import {Stack, styled} from '@mui/material';

const StyledStack = styled(Stack)`
	justify-content: flex-start;
	align-items: flex-start;
	gap: 4px;
	padding: 16px;
	margin-bottom: 24px;
	box-sizing: border-box;
	border: ${({theme}) => `1px solid ${theme.palette.divider}`};
	border-radius: 8px;
`;

export {StyledStack};
